// This file is auto-generated by @hey-api/openapi-ts

export const $Body_update_master_chases_bulk_chases_provider_bulk_patch = {
    properties: {
        master_chase_update_request: {
            '$ref': '#/components/schemas/MasterChaseUpdateRequest'
        },
        master_chase_uuids_legacy_ids_dict: {
            additionalProperties: {
                additionalProperties: true,
                type: 'object'
            },
            type: 'object',
            title: 'Master Chase Uuids Legacy Ids Dict'
        }
    },
    type: 'object',
    required: ['master_chase_update_request', 'master_chase_uuids_legacy_ids_dict'],
    title: 'Body_update_master_chases_bulk_chases_provider_bulk_patch'
} as const;

export const $Body_update_master_chases_with_data_coordinate_pk_ids_bulk_chases_provider_bulk_v2_patch = {
    properties: {
        master_chase_update_request: {
            '$ref': '#/components/schemas/MasterChaseUpdateRequest'
        },
        data_coordinate_pk_ids: {
            items: {
                type: 'integer'
            },
            type: 'array',
            title: 'Data Coordinate Pk Ids'
        }
    },
    type: 'object',
    required: ['master_chase_update_request', 'data_coordinate_pk_ids'],
    title: 'Body_update_master_chases_with_data_coordinate_pk_ids_bulk_chases_provider_bulk_v2_patch'
} as const;

export const $BulkUpload = {
    properties: {
        bulk_upload_id: {
            type: 'integer',
            title: 'Bulk Upload Id',
            description: 'The unique identifier of the bulk upload'
        },
        uuid: {
            type: 'string',
            title: 'Uuid',
            description: 'The UUID of the bulk upload, used for tracking and identification'
        },
        tenant_id: {
            type: 'string',
            title: 'Tenant Id',
            description: 'The unique identifier for the tenant associated with the bulk upload'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            title: 'Created At',
            description: 'DateTime when the bulk upload was created'
        },
        updated_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Updated At',
            description: 'DateTime when the bulk upload was last updated'
        },
        num_files: {
            type: 'integer',
            title: 'Num Files',
            description: 'The number of files in the bulk upload'
        },
        outreach_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Outreach Id',
            description: 'The outreach ID associated with the bulk upload'
        },
        provider_package_display_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider Package Display Id',
            description: 'The provider package display ID associated with the bulk upload'
        },
        files: {
            items: {
                '$ref': '#/components/schemas/BulkUploadFile'
            },
            type: 'array',
            title: 'Files',
            description: 'Information about the files in the bulk upload'
        }
    },
    type: 'object',
    required: ['bulk_upload_id', 'uuid', 'tenant_id', 'created_at', 'updated_at', 'num_files', 'files'],
    title: 'BulkUpload'
} as const;

export const $BulkUploadAiProcessedResult = {
    properties: {
        pk_id: {
            type: 'integer',
            title: 'Pk Id'
        },
        group_id: {
            type: 'string',
            title: 'Group Id'
        },
        reference_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reference Id'
        },
        original_file_upload_uuids: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Original File Upload Uuids'
        },
        generated_file_upload_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Generated File Upload Uuid'
        },
        final_cdr_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Final Cdr Uuid'
        },
        original_cdr_uuids: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Original Cdr Uuids'
        },
        status: {
            '$ref': '#/components/schemas/BulkUploadAiProcessingResultEnum'
        },
        upload_origin: {
            '$ref': '#/components/schemas/BulkUploadAiProcessingUploadOriginEnum'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            title: 'Created At'
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            title: 'Updated At'
        }
    },
    type: 'object',
    required: ['pk_id', 'group_id', 'original_file_upload_uuids', 'status', 'upload_origin', 'created_at', 'updated_at'],
    title: 'BulkUploadAiProcessedResult'
} as const;

export const $BulkUploadAiProcessingRequestOriginEnum = {
    type: 'string',
    enum: ['CHARTFINDER', 'HUB', 'IDSB'],
    title: 'BulkUploadAiProcessingRequestOriginEnum'
} as const;

export const $BulkUploadAiProcessingResultEnum = {
    type: 'string',
    enum: ['SUCCESS', 'MULTIPLE_PATIENTS_FOUND_FAILURE', 'NO_PATIENTS_FOUND_FAILURE', 'NO_GROUP_MATCH_FAILURE', 'MULTIPLE_MATCHES_IN_GROUP_FAILURE', 'NO_CHARTS_IN_GROUP_FAILURE'],
    title: 'BulkUploadAiProcessingResultEnum'
} as const;

export const $BulkUploadAiProcessingUploadOriginEnum = {
    type: 'string',
    enum: ['RMS', 'RMB'],
    title: 'BulkUploadAiProcessingUploadOriginEnum'
} as const;

export const $BulkUploadAiRawResult = {
    properties: {
        pk_id: {
            type: 'integer',
            title: 'Pk Id'
        },
        cdr_uuid: {
            type: 'string',
            title: 'Cdr Uuid'
        },
        original_file_upload_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Original File Upload Uuid'
        },
        group_id: {
            type: 'string',
            title: 'Group Id'
        },
        patient_info: {
            anyOf: [
                {
                    items: {
                        additionalProperties: true,
                        type: 'object'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Patient Info'
        },
        request_origin: {
            '$ref': '#/components/schemas/BulkUploadAiProcessingRequestOriginEnum'
        },
        upload_origin: {
            '$ref': '#/components/schemas/BulkUploadAiProcessingUploadOriginEnum'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            title: 'Created At'
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            title: 'Updated At'
        }
    },
    type: 'object',
    required: ['pk_id', 'cdr_uuid', 'group_id', 'request_origin', 'upload_origin', 'created_at', 'updated_at'],
    title: 'BulkUploadAiRawResult'
} as const;

export const $BulkUploadFile = {
    properties: {
        file_name: {
            type: 'string',
            title: 'File Name',
            description: 'The name of the uploaded file'
        },
        uuid: {
            type: 'string',
            title: 'Uuid',
            description: 'The UUID of the uploaded file'
        },
        provider_specified_file_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider Specified File Name',
            description: 'The name of the file that provider specified'
        },
        file_path: {
            type: 'string',
            title: 'File Path',
            description: 'The path of the uploaded file'
        },
        file_status: {
            '$ref': '#/components/schemas/BulkUploadFileStatus',
            description: 'The status of the file'
        },
        file_status_metadata: {
            additionalProperties: true,
            type: 'object',
            title: 'File Status Metadata',
            description: 'Metadata about the file status'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            title: 'Created At',
            description: 'DateTime when the file was uploaded'
        },
        updated_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Updated At',
            description: 'DateTime when the file was last updated'
        },
        cdr_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cdr Uuid',
            description: 'The cdr uuid for file'
        }
    },
    type: 'object',
    required: ['file_name', 'uuid', 'file_path', 'file_status', 'file_status_metadata', 'created_at', 'updated_at'],
    title: 'BulkUploadFile'
} as const;

export const $BulkUploadFilePatchRequest = {
    properties: {
        uuid: {
            type: 'string',
            title: 'Uuid',
            description: 'The UUID of the file'
        },
        file_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'File Name',
            description: 'The name of the uploaded file'
        },
        provider_specified_file_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider Specified File Name',
            description: 'The name of the file that provider specified'
        },
        file_path: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'File Path',
            description: 'The path of the uploaded file'
        },
        file_status: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/BulkUploadFileStatus'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The status of the file'
        },
        file_status_metadata: {
            anyOf: [
                {
                    additionalProperties: true,
                    type: 'object'
                },
                {
                    type: 'null'
                }
            ],
            title: 'File Status Metadata',
            description: 'Metadata about the file status'
        },
        cdr_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cdr Uuid',
            description: 'The cdr uuid for file'
        }
    },
    type: 'object',
    required: ['uuid'],
    title: 'BulkUploadFilePatchRequest'
} as const;

export const $BulkUploadFileRequest = {
    properties: {
        file_name: {
            type: 'string',
            title: 'File Name',
            description: 'The name of the uploaded file'
        },
        file_path: {
            type: 'string',
            title: 'File Path',
            description: 'The path of the uploaded file'
        },
        provider_specified_file_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider Specified File Name',
            description: 'The name of the file that provider specified'
        },
        file_status: {
            '$ref': '#/components/schemas/BulkUploadFileStatus',
            description: 'The status of the file',
            default: 'UPLOADED_S3'
        },
        file_status_metadata: {
            additionalProperties: true,
            type: 'object',
            title: 'File Status Metadata',
            description: 'Metadata about the file status',
            default: {}
        },
        cdr_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cdr Uuid',
            description: 'The cdr uuid for file'
        }
    },
    type: 'object',
    required: ['file_name', 'file_path'],
    title: 'BulkUploadFileRequest'
} as const;

export const $BulkUploadFileStatus = {
    type: 'string',
    enum: ['UPLOADED_S3', 'UPLOADING_AZURE_FILESHARE', 'UPLOADING_AZURE_FILESHARE_FAILED', 'UPLOADED_AZURE_FILESHARE', 'UPLOADING_HUB_FAILED', 'UPLOADING_HUB', 'UPLOADED_HUB', 'UPLOADING_CDR', 'UPLOADING_CDR_FAILED', 'UPLOADED_CDR', 'AI_PROCESSING_SUCCESSFUL', 'AI_PROCESSING_FAILED', 'AI_RESULT_READY', 'SENT_FOR_AI_PROCESSING'],
    title: 'BulkUploadFileStatus'
} as const;

export const $BulkUploadForOutreachFileRequest = {
    properties: {
        uuid: {
            type: 'string',
            title: 'Uuid'
        },
        file_name: {
            type: 'string',
            title: 'File Name'
        },
        provider_specified_file_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider Specified File Name'
        },
        file_path: {
            type: 'string',
            title: 'File Path'
        },
        file_size: {
            type: 'string',
            title: 'File Size'
        },
        user_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Uuid'
        },
        cdr_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cdr Uuid'
        }
    },
    type: 'object',
    required: ['uuid', 'file_name', 'file_path', 'file_size'],
    title: 'BulkUploadForOutreachFileRequest'
} as const;

export const $BulkUploadForOutreachRequest = {
    properties: {
        files: {
            items: {
                '$ref': '#/components/schemas/BulkUploadForOutreachFileRequest'
            },
            type: 'array',
            title: 'Files',
            description: 'Information about the files in the bulk upload'
        },
        chart_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Chart Id',
            description: 'The optional chart id associated with the bulk upload'
        },
        record_request_display_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Record Request Display Id',
            description: 'The optional record request display id associated with the bulk upload'
        }
    },
    type: 'object',
    required: ['files'],
    title: 'BulkUploadForOutreachRequest'
} as const;

export const $BulkUploadNoChildFiles = {
    properties: {
        bulk_upload_id: {
            type: 'integer',
            title: 'Bulk Upload Id',
            description: 'The unique identifier of the bulk upload'
        },
        uuid: {
            type: 'string',
            title: 'Uuid',
            description: 'The UUID of the bulk upload, used for tracking and identification'
        },
        tenant_id: {
            type: 'string',
            title: 'Tenant Id',
            description: 'The unique identifier for the tenant associated with the bulk upload'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            title: 'Created At',
            description: 'DateTime when the bulk upload was created'
        },
        updated_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Updated At',
            description: 'DateTime when the bulk upload was last updated'
        },
        num_files: {
            type: 'integer',
            title: 'Num Files',
            description: 'The number of files in the bulk upload'
        },
        outreach_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Outreach Id',
            description: 'The outreach ID associated with the bulk upload'
        },
        provider_package_display_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider Package Display Id',
            description: 'The provider package display ID associated with the bulk upload'
        }
    },
    type: 'object',
    required: ['bulk_upload_id', 'uuid', 'tenant_id', 'created_at', 'updated_at', 'num_files'],
    title: 'BulkUploadNoChildFiles'
} as const;

export const $BulkUploadPatientAIResult = {
    properties: {
        start_page_number: {
            type: 'integer',
            title: 'Start Page Number',
            description: 'The starting page number for AI results'
        },
        first_name: {
            type: 'string',
            title: 'First Name',
            description: "The patient's first name extracted from AI results"
        },
        last_name: {
            type: 'string',
            title: 'Last Name',
            description: "The patient's last name extracted from AI results"
        },
        date_of_birth: {
            type: 'string',
            title: 'Date Of Birth',
            description: "The patient's date of birth extracted from AI results in yyyy-mm-dd format"
        }
    },
    type: 'object',
    required: ['start_page_number', 'first_name', 'last_name', 'date_of_birth'],
    title: 'BulkUploadPatientAIResult'
} as const;

export const $BulkUploadRequest = {
    properties: {
        files: {
            items: {
                '$ref': '#/components/schemas/BulkUploadFileRequest'
            },
            type: 'array',
            title: 'Files',
            description: 'Information about the files in the bulk upload'
        },
        outreach_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Outreach Id',
            description: 'The outreach ID associated with the bulk upload'
        },
        provider_package_display_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider Package Display Id',
            description: 'The provider package display ID associated with the bulk upload'
        },
        upload_uuid: {
            type: 'string',
            title: 'Upload Uuid',
            description: 'The UUID of the bulk upload'
        }
    },
    type: 'object',
    required: ['files', 'upload_uuid'],
    title: 'BulkUploadRequest'
} as const;

export const $ChartRepushRequest = {
    properties: {
        chart_ids: {
            items: {
                type: 'integer'
            },
            type: 'array',
            title: 'Chart Ids'
        }
    },
    type: 'object',
    required: ['chart_ids'],
    title: 'ChartRepushRequest'
} as const;

export const $ChartRepushResult = {
    properties: {
        successful_chart_uploads: {
            items: {
                type: 'integer'
            },
            type: 'array',
            title: 'Successful Chart Uploads'
        },
        failed_chart_uploads: {
            items: {
                type: 'integer'
            },
            type: 'array',
            title: 'Failed Chart Uploads'
        }
    },
    type: 'object',
    required: ['successful_chart_uploads', 'failed_chart_uploads'],
    title: 'ChartRepushResult'
} as const;

export const $ChaseStatus = {
    type: 'string',
    enum: ['CREATED', 'GRACE_PERIOD_NEEDED', 'GRACE_PERIOD_STARTED', 'GRACE_PERIOD_ENDED', 'PROVIDER_PACKET_NEEDED', 'PATIENT_CONSENT_REVIEW_REQUIRED', 'PATIENT_CONSENT_REVIEW_DENIED', 'READY_TO_DISPATCH', 'SENT_FOR_PROCESSING', 'IN_PROCESSING', 'CHARTS_NOT_FOUND', 'CHARTS_READY_FOR_DOWNLOAD', 'CHARTS_BEING_DOWNLOADED', 'CHARTS_DOWNLOADED', 'CANCELLED', 'FAILED', 'PROVIDER_NOT_PARTICIPATING', 'ACTION_NEEDED', 'CHARTS_AVAILABLE', 'SENT_TO_CHARTFINDER_FOR_PROCESSING'],
    title: 'ChaseStatus',
    description: `Internal status of a Chase.

CREATED                     :Chase has been created and is awaiting further action
GRACE_PERIOD_NEEDED         :Chase is waiting to start the grace period
GRACE_PERIOD_STARTED        :Chase is in the grace period and can be edited or cancelled
GRACE_PERIOD_ENDED          :Chase has exited the grace period and can no longer be edited or cancelled
PATIENT_CONSENT_REVIEW_REQUIRED    :Chase needs a review of the patient consent in order to be dispatched
PATIENT_CONSENT_REVIEW_DENIED      :Chase required patient consent but it was denied during review
READY_TO_DISPATCH           :Chase is ready to be dispatched and is waiting to be picked up
SENT_FOR_PROCESSING         :Chase has been sent to fulfillment method and is awaiting response
IN_PROCESSING               :Chase is currently being processed
CHARTS_NOT_FOUND            :Chase has not resulted in a chart
CHARTS_READY_FOR_DOWNLOAD   :Chase has charts that are ready to be downloaded from the retrieval source
CHARTS_BEING_DOWNLOADED     :We're currently downloaded the charts for this chase from the retrieval source
CHARTS_DOWNLOADED   :All charts for the chase are ready within the IDSB system
CANCELLED    :Chase has been intentionally cancelled
FAILED       :Chase has failed for unexpected reasons
PROVIDER_PACKET_NEEDED  :Chase needs a provider packet to be created and attached to be ready for dispatching
ACTION_NEEDED   :Chase requires action that isn't captured by other statuses
CHARTS_AVAILABLE:   :Chase has charts that have finished qc and are available for download
SENT_TO_CHARTFINDER_FOR_PROCESSING :A Provider has sent a response to Chartfinder, waiting for response from Chartfinder to update chase`
} as const;

export const $ClearPreviousEnum = {
    type: 'string',
    enum: ['ALL', 'FAILED', 'IN_PROGRESS'],
    title: 'ClearPreviousEnum'
} as const;

export const $CreateAddressFeedbackRequest = {
    properties: {
        tenant_uuid: {
            type: 'string',
            title: 'Tenant Uuid',
            description: 'The tenant UUID the feedback is for.'
        },
        user_uuid: {
            type: 'string',
            title: 'User Uuid',
            description: "The provider user's UUID who submitted the feedback."
        },
        addresses: {
            items: {
                '$ref': '#/components/schemas/DigitalAddressFeedback'
            },
            type: 'array',
            title: 'Addresses',
            description: 'The addresses that are being submitted for feedback.'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: ['tenant_uuid', 'user_uuid', 'addresses'],
    title: 'CreateAddressFeedbackRequest'
} as const;

export const $CreateAddressFeedbackSnowflakeRequest = {
    properties: {
        tenant_uuid: {
            type: 'string',
            title: 'Tenant Uuid',
            description: 'The tenant UUID the feedback is for.'
        },
        health_system_name: {
            type: 'string',
            title: 'Health System Name',
            description: 'The name of the health system.'
        },
        digital_site_id: {
            type: 'integer',
            title: 'Digital Site Id',
            description: 'The digital site ID.'
        },
        health_system_id: {
            type: 'string',
            title: 'Health System Id',
            description: 'The health system ID.'
        },
        emr: {
            type: 'string',
            title: 'Emr',
            description: 'The EMR system used.'
        },
        connection_type: {
            type: 'string',
            title: 'Connection Type',
            description: 'Digital connection type.'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: ['tenant_uuid', 'health_system_name', 'digital_site_id', 'health_system_id', 'emr', 'connection_type'],
    title: 'CreateAddressFeedbackSnowflakeRequest'
} as const;

export const $CreateAiRawResultParams = {
    properties: {
        cdr_uuid: {
            type: 'string',
            title: 'Cdr Uuid'
        },
        group_id: {
            type: 'string',
            title: 'Group Id'
        },
        request_origin: {
            '$ref': '#/components/schemas/BulkUploadAiProcessingRequestOriginEnum'
        },
        upload_origin: {
            '$ref': '#/components/schemas/BulkUploadAiProcessingUploadOriginEnum'
        },
        original_file_upload_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Original File Upload Uuid'
        }
    },
    type: 'object',
    required: ['cdr_uuid', 'group_id', 'request_origin', 'upload_origin'],
    title: 'CreateAiRawResultParams'
} as const;

export const $CreateDigitalAgreement = {
    properties: {
        tenant_uuid: {
            type: 'string',
            title: 'Tenant Uuid',
            description: 'The tenant UUID of the user that signed the agreement.'
        },
        user_uuid: {
            type: 'string',
            title: 'User Uuid',
            description: "The provider user's UUID who signed the agreement."
        },
        agreement_id: {
            type: 'string',
            title: 'Agreement Id',
            description: 'The ID of the agreement that the user signed.'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: ['tenant_uuid', 'user_uuid', 'agreement_id'],
    title: 'CreateDigitalAgreement'
} as const;

export const $CreateDigitalEncounterFeedback = {
    properties: {
        tenant_uuid: {
            type: 'string',
            title: 'Tenant Uuid',
            description: 'UUID of the tenant associated to the encounter feedback'
        },
        encounters: {
            items: {
                '$ref': '#/components/schemas/CreateDigitalEncounterFeedbackEntry'
            },
            type: 'array',
            title: 'Encounters',
            description: 'List of encounter feedback entries to be created'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: ['tenant_uuid', 'encounters'],
    title: 'CreateDigitalEncounterFeedback'
} as const;

export const $CreateDigitalEncounterFeedbackEntry = {
    properties: {
        encounter_type: {
            type: 'string',
            title: 'Encounter Type',
            description: 'The encounter type name'
        },
        active: {
            type: 'boolean',
            title: 'Active',
            description: 'Whether the encounter type is active for autofulfillment'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: ['encounter_type', 'active'],
    title: 'CreateDigitalEncounterFeedbackEntry'
} as const;

export const $CreateDigitalScannedDocumentFeedback = {
    properties: {
        tenant_uuid: {
            type: 'string',
            title: 'Tenant Uuid',
            description: 'UUID of the tenant associated to the scanned document feedback'
        },
        documents: {
            items: {
                '$ref': '#/components/schemas/CreateDigitalScannedDocumentFeedbackEntry'
            },
            type: 'array',
            title: 'Documents',
            description: 'List of scanned document feedback entries to be created'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: ['tenant_uuid', 'documents'],
    title: 'CreateDigitalScannedDocumentFeedback'
} as const;

export const $CreateDigitalScannedDocumentFeedbackEntry = {
    properties: {
        document_category: {
            type: 'string',
            title: 'Document Category',
            description: 'The scanned document category name'
        },
        active: {
            type: 'boolean',
            title: 'Active',
            description: 'Whether the document category is active for autofulfillment'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: ['document_category', 'active'],
    title: 'CreateDigitalScannedDocumentFeedbackEntry'
} as const;

export const $DataCoordinateCountRequest = {
    properties: {
        health_system_filters: {
            '$ref': '#/components/schemas/DataCoordinateHealthSystemFilters'
        },
        search_filters: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/DataCoordinateSearchFilters'
                },
                {
                    type: 'null'
                }
            ]
        },
        include_provider_verification_filter: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Include Provider Verification Filter',
            default: true
        }
    },
    type: 'object',
    required: ['health_system_filters'],
    title: 'DataCoordinateCountRequest'
} as const;

export const $DataCoordinateEmailNotificationResponse = {
    properties: {
        count_due_in_7_days: {
            type: 'integer',
            title: 'Count Due In 7 Days',
            description: 'Count of chases due in 7 days (less than or equal to 7 days from today). The display date is used if it exists, otherwise the due date.',
            default: 0
        },
        count_total: {
            type: 'integer',
            title: 'Count Total',
            description: 'Total count of pending chases.',
            default: 0
        },
        group_ids_data: {
            additionalProperties: {
                additionalProperties: {
                    type: 'string'
                },
                type: 'object'
            },
            type: 'object',
            title: 'Group Ids Data',
            description: "Key: Group ID, Value: dict containing 'request_origin'",
            default: {}
        }
    },
    type: 'object',
    title: 'DataCoordinateEmailNotificationResponse'
} as const;

export const $DataCoordinateExpireAccepted = {
    properties: {
        tenant_uuid: {
            type: 'string',
            title: 'Tenant Uuid'
        },
        status: {
            type: 'string',
            title: 'Status',
            default: 'accepted'
        }
    },
    type: 'object',
    required: ['tenant_uuid'],
    title: 'DataCoordinateExpireAccepted'
} as const;

export const $DataCoordinateExpireRequest = {
    properties: {
        tenant_uuid: {
            type: 'string',
            title: 'Tenant Uuid'
        },
        run_display_due_date_calculation: {
            type: 'boolean',
            title: 'Run Display Due Date Calculation',
            default: false
        }
    },
    type: 'object',
    required: ['tenant_uuid'],
    title: 'DataCoordinateExpireRequest'
} as const;

export const $DataCoordinateForDeniedProvidersResponse = {
    properties: {
        data_coordinates: {
            items: {
                '$ref': '#/components/schemas/PydanticDataCoordinate'
            },
            type: 'array',
            title: 'Data Coordinates'
        }
    },
    type: 'object',
    required: ['data_coordinates'],
    title: 'DataCoordinateForDeniedProvidersResponse'
} as const;

export const $DataCoordinateHealthSystemFilters = {
    properties: {
        cf_site_clean_ids: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cf Site Clean Ids'
        },
        phone_numbers: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phone Numbers'
        },
        fax_numbers: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fax Numbers'
        },
        health_system_ids: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Health System Ids'
        },
        df_master_address_keys: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Df Master Address Keys'
        }
    },
    type: 'object',
    title: 'DataCoordinateHealthSystemFilters'
} as const;

export const $DataCoordinateHealthSystemFiltersInternal = {
    properties: {
        cf_site_clean_ids: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cf Site Clean Ids'
        },
        phone_numbers: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phone Numbers'
        },
        fax_numbers: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fax Numbers'
        },
        health_system_ids: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Health System Ids'
        },
        df_master_address_keys: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Df Master Address Keys'
        }
    },
    type: 'object',
    title: 'DataCoordinateHealthSystemFiltersInternal'
} as const;

export const $DataCoordinateIdentifiersResponse = {
    properties: {
        phone_numbers: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Phone Numbers',
            default: []
        },
        fax_numbers: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Fax Numbers',
            default: []
        },
        health_system_ids: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Health System Ids',
            default: []
        },
        master_address_keys: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Master Address Keys',
            default: []
        }
    },
    type: 'object',
    title: 'DataCoordinateIdentifiersResponse'
} as const;

export const $DataCoordinateQueueRequest = {
    properties: {
        health_system_filters: {
            '$ref': '#/components/schemas/DataCoordinateHealthSystemFilters'
        },
        search_filters: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/DataCoordinateSearchFilters'
                },
                {
                    type: 'null'
                }
            ]
        },
        sort: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/DataCoordinateSort'
                },
                {
                    type: 'null'
                }
            ]
        },
        limit: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Limit'
        },
        offset: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Offset'
        },
        include_total: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Include Total',
            default: false
        },
        exclude_pnp: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Exclude Pnp',
            default: true
        },
        include_provider_verification_filter: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Include Provider Verification Filter',
            default: false
        }
    },
    type: 'object',
    required: ['health_system_filters', 'search_filters', 'sort', 'limit', 'offset'],
    title: 'DataCoordinateQueueRequest'
} as const;

export const $DataCoordinateQueueRequestInternal = {
    properties: {
        health_system_filters: {
            '$ref': '#/components/schemas/DataCoordinateHealthSystemFiltersInternal'
        },
        search_filters: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/DataCoordinateSearchFilters'
                },
                {
                    type: 'null'
                }
            ]
        },
        sort: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/DataCoordinateSort'
                },
                {
                    type: 'null'
                }
            ]
        },
        limit: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Limit'
        },
        offset: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Offset'
        },
        include_total: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Include Total',
            default: false
        },
        exclude_pnp: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Exclude Pnp',
            default: true
        },
        include_provider_verification_filter: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Include Provider Verification Filter',
            default: false
        }
    },
    type: 'object',
    required: ['health_system_filters', 'sort', 'limit', 'offset'],
    title: 'DataCoordinateQueueRequestInternal'
} as const;

export const $DataCoordinateQueueResponse = {
    properties: {
        data_coordinates: {
            items: {
                '$ref': '#/components/schemas/PydanticDataCoordinate'
            },
            type: 'array',
            title: 'Data Coordinates'
        },
        total: {
            type: 'integer',
            title: 'Total'
        }
    },
    type: 'object',
    required: ['data_coordinates', 'total'],
    title: 'DataCoordinateQueueResponse'
} as const;

export const $DataCoordinateSearchFilters = {
    properties: {
        pk_ids: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Pk Ids'
        },
        global_search: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Global Search'
        },
        outreach_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Outreach Id'
        },
        chart_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Chart Id'
        },
        chart_ids: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Chart Ids'
        },
        patient_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Patient Name'
        },
        patient_dob: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Patient Dob'
        },
        statuses_include: {
            anyOf: [
                {
                    items: {
                        '$ref': '#/components/schemas/RequestManagerRetrievalStatus'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Statuses Include'
        },
        statuses_exclude: {
            anyOf: [
                {
                    items: {
                        '$ref': '#/components/schemas/RequestManagerRetrievalStatus'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Statuses Exclude'
        },
        practitioner_names: {
            anyOf: [
                {
                    items: {
                        '$ref': '#/components/schemas/PractitionerName'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Practitioner Names'
        },
        due_date_start: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Date Start'
        },
        due_date_end: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Date End'
        },
        primary_reasons: {
            anyOf: [
                {
                    items: {
                        '$ref': '#/components/schemas/PrimaryReason'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Primary Reasons'
        },
        retrieval_methods: {
            anyOf: [
                {
                    items: {
                        '$ref': '#/components/schemas/RequestManagerRetrievalMethod'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Retrieval Methods'
        },
        rra_filter: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/RRAFilter'
                },
                {
                    type: 'null'
                }
            ]
        },
        request_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Request Id'
        },
        reference_ids: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reference Ids'
        },
        group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Group Id'
        }
    },
    type: 'object',
    title: 'DataCoordinateSearchFilters'
} as const;

export const $DataCoordinateSort = {
    properties: {
        option: {
            '$ref': '#/components/schemas/RequestManagerSortOption',
            default: 'due_date'
        },
        direction: {
            anyOf: [
                {
                    type: 'string',
                    const: 'asc'
                },
                {
                    type: 'string',
                    const: 'desc'
                }
            ],
            title: 'Direction',
            default: 'asc'
        }
    },
    type: 'object',
    title: 'DataCoordinateSort'
} as const;

export const $DataCoordinateUpdateFields = {
    properties: {
        status: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/RequestManagerRetrievalStatus'
                },
                {
                    type: 'null'
                }
            ]
        },
        status_detail: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status Detail'
        },
        assigned_to_health_system_ids_to_add: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Assigned To Health System Ids To Add'
        },
        assigned_to_health_system_ids_to_remove: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Assigned To Health System Ids To Remove'
        },
        fulfilled_by_health_system_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fulfilled By Health System Id'
        },
        display_due_date: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Display Due Date'
        },
        cdr_document_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cdr Document Id'
        }
    },
    type: 'object',
    title: 'DataCoordinateUpdateFields'
} as const;

export const $DataCoordinateUpdateRequest = {
    properties: {
        health_system_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Health System Id'
        },
        health_system_filters: {
            '$ref': '#/components/schemas/DataCoordinateHealthSystemFilters'
        },
        search_filters: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/DataCoordinateSearchFilters'
                },
                {
                    type: 'null'
                }
            ]
        },
        update_fields: {
            '$ref': '#/components/schemas/DataCoordinateUpdateFields'
        },
        exclude_pnp: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Exclude Pnp',
            default: true
        }
    },
    type: 'object',
    required: ['health_system_filters', 'update_fields'],
    title: 'DataCoordinateUpdateRequest'
} as const;

export const $DataCoordinateUpdateRequestInternal = {
    properties: {
        health_system_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Health System Id'
        },
        health_system_filters: {
            '$ref': '#/components/schemas/DataCoordinateHealthSystemFiltersInternal'
        },
        search_filters: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/DataCoordinateSearchFilters'
                },
                {
                    type: 'null'
                }
            ]
        },
        update_fields: {
            '$ref': '#/components/schemas/DataCoordinateUpdateFields'
        },
        exclude_pnp: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Exclude Pnp',
            default: true
        }
    },
    type: 'object',
    required: ['health_system_filters', 'update_fields'],
    title: 'DataCoordinateUpdateRequestInternal'
} as const;

export const $DedaSuccessfulEventRequest = {
    properties: {
        request_id: {
            type: 'string',
            title: 'Request Id'
        },
        cdr_document_uuid: {
            type: 'string',
            format: 'uuid',
            title: 'Cdr Document Uuid'
        }
    },
    type: 'object',
    required: ['request_id', 'cdr_document_uuid'],
    title: 'DedaSuccessfulEventRequest'
} as const;

export const $DedaUnsuccessfulEventRequest = {
    properties: {
        request_id: {
            type: 'string',
            title: 'Request Id'
        },
        reason: {
            type: 'string',
            title: 'Reason'
        }
    },
    type: 'object',
    required: ['request_id', 'reason'],
    title: 'DedaUnsuccessfulEventRequest'
} as const;

export const $DigitalAddressFeedback = {
    properties: {
        approved: {
            type: 'boolean',
            title: 'Approved',
            description: 'Whether the address feedback is approved or not.'
        },
        address_line_1: {
            type: 'string',
            title: 'Address Line 1',
            description: 'The address line 1 of the address feedback.'
        },
        address_line_2: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Line 2',
            description: 'The address line 2 of the address feedback.'
        },
        city: {
            type: 'string',
            title: 'City',
            description: 'The city of the address feedback.'
        },
        state: {
            type: 'string',
            title: 'State',
            description: 'The state of the address feedback.'
        },
        postal_code: {
            type: 'string',
            title: 'Postal Code',
            description: 'The postal code of the address feedback.'
        },
        mak: {
            type: 'string',
            title: 'Mak',
            description: 'The Master Address Key of the address feedback.'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: ['approved', 'address_line_1', 'address_line_2', 'city', 'state', 'postal_code', 'mak'],
    title: 'DigitalAddressFeedback'
} as const;

export const $DigitalAgreement = {
    properties: {
        pk_id: {
            type: 'integer',
            title: 'Pk Id',
            description: 'The primary key ID of the digital agreement.'
        },
        tenant_uuid: {
            type: 'string',
            title: 'Tenant Uuid',
            description: 'The tenant UUID of the user that signed the agreement.'
        },
        user_uuid: {
            type: 'string',
            title: 'User Uuid',
            description: "The provider user's UUID who signed the agreement."
        },
        agreement_id: {
            type: 'string',
            title: 'Agreement Id',
            description: 'The ID of the agreement that the user signed.'
        },
        deleted: {
            type: 'boolean',
            title: 'Deleted',
            description: 'Whether the agreement has been deleted.'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            title: 'Created At',
            description: 'The timestamp when the agreement was created.'
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            title: 'Updated At',
            description: 'The timestamp when the agreement was last updated.'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: ['pk_id', 'tenant_uuid', 'user_uuid', 'agreement_id', 'deleted', 'created_at', 'updated_at'],
    title: 'DigitalAgreement'
} as const;

export const $DigitalEncounterFeedback = {
    properties: {
        pk_id: {
            type: 'integer',
            title: 'Pk Id',
            description: 'Id of the encounter feedback entry'
        },
        tenant_uuid: {
            type: 'string',
            title: 'Tenant Uuid',
            description: 'UUID of the tenant associated to the encounter feedback'
        },
        encounter_type: {
            type: 'string',
            title: 'Encounter Type',
            description: 'The encounter type name'
        },
        active: {
            type: 'boolean',
            title: 'Active',
            description: 'Whether the encounter type is active for autofulfillment'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            title: 'Created At',
            description: 'Date and time when the encounter feedback was created'
        },
        updated_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Updated At',
            description: 'Date and time when the encounter feedback was last updated'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: ['pk_id', 'tenant_uuid', 'encounter_type', 'active', 'created_at', 'updated_at'],
    title: 'DigitalEncounterFeedback'
} as const;

export const $DigitalQCBulkUpdateChart = {
    properties: {
        pk_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Pk Id',
            description: 'The primary key of the Digital QC record.'
        },
        data_coordinate_pk_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Data Coordinate Pk Id',
            description: 'The data coordinate ID associated with the Digital QC record.'
        },
        status: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/StatusEnum'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The status of the Digital QC record.'
        },
        status_message: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status Message',
            description: 'The status message of the quality check fulfillment.'
        },
        document_location: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Location',
            description: 'The CDR document location of the quality check records.'
        },
        approved: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approved',
            description: 'Whether the record was approved.'
        },
        feedback: {
            anyOf: [
                {
                    items: {
                        '$ref': '#/components/schemas/RejectReasonsEnum'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Feedback',
            description: 'The feedback categories for the Digital QC record.'
        },
        feedback_comment: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Feedback Comment',
            description: 'The feedback comment for the Digital QC record.'
        },
        feedback_email: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Feedback Email',
            description: 'The feedback email for the Digital QC record.'
        },
        deleted: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted',
            description: 'Whether the record was deleted.'
        }
    },
    additionalProperties: false,
    type: 'object',
    title: 'DigitalQCBulkUpdateChart'
} as const;

export const $DigitalQCBulkUpdateReponse = {
    properties: {
        successes: {
            items: {
                '$ref': '#/components/schemas/PydanticQualityCheck'
            },
            type: 'array',
            title: 'Successes',
            description: 'The list of successfully updated QC records.'
        },
        failures: {
            items: {
                type: 'integer'
            },
            type: 'array',
            title: 'Failures',
            description: 'The pk_ids/data_coordinate_pk_ids of failed QC record updates.'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: ['successes', 'failures'],
    title: 'DigitalQCBulkUpdateReponse'
} as const;

export const $DigitalQCBulkUpdateRequest = {
    properties: {
        charts: {
            items: {
                '$ref': '#/components/schemas/DigitalQCBulkUpdateChart'
            },
            type: 'array',
            title: 'Charts'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: ['charts'],
    title: 'DigitalQCBulkUpdateRequest'
} as const;

export const $DigitalQCBulkUpdateStatus = {
    properties: {
        chart_id: {
            type: 'integer',
            title: 'Chart Id',
            description: 'The reference ID (chart ID or data coordinate ID) associated with the quality check.'
        },
        status: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/StatusEnum'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The status of the Digital QC record.'
        },
        status_message: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status Message',
            description: 'The status message of the quality check fulfillment.'
        },
        document_location: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Location',
            description: 'The CDR document location of the quality check records.'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: ['chart_id'],
    title: 'DigitalQCBulkUpdateStatus'
} as const;

export const $DigitalQCChart = {
    properties: {
        data_coordinate_pk_id: {
            type: 'integer',
            title: 'Data Coordinate Pk Id',
            description: 'The data coordinate primary key ID associated with the quality check.'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: ['data_coordinate_pk_id'],
    title: 'DigitalQCChart'
} as const;

export const $DigitalQCCreateRequest = {
    properties: {
        tenant_uuid: {
            type: 'string',
            title: 'Tenant Uuid',
            description: 'The tenant UUID the quality check is for.'
        },
        owner_email: {
            type: 'string',
            title: 'Owner Email',
            description: 'The DVer email that triggered the quality check.'
        },
        charts: {
            anyOf: [
                {
                    items: {
                        '$ref': '#/components/schemas/DigitalQCChart'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Charts',
            description: 'The charts that comprise the quality check.'
        },
        health_system_filters: {
            '$ref': '#/components/schemas/DataCoordinateHealthSystemFilters',
            description: 'Compliance requirements to make sure charts belong to health system.'
        },
        clear_previous: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/ClearPreviousEnum'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Whether to clear previous QC attempts when restarting QC.'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: ['tenant_uuid', 'owner_email', 'health_system_filters'],
    title: 'DigitalQCCreateRequest'
} as const;

export const $DigitalScannedDocumentFeedback = {
    properties: {
        pk_id: {
            type: 'integer',
            title: 'Pk Id',
            description: 'Id of the scanned document feedback entry'
        },
        tenant_uuid: {
            type: 'string',
            title: 'Tenant Uuid',
            description: 'UUID of the tenant associated to the scanned document feedback'
        },
        document_category: {
            type: 'string',
            title: 'Document Category',
            description: 'The scanned document category name'
        },
        active: {
            type: 'boolean',
            title: 'Active',
            description: 'Whether the document category is active for autofulfillment'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            title: 'Created At',
            description: 'Date and time when the scanned document feedback was created'
        },
        updated_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Updated At',
            description: 'Date and time when the scanned document feedback was last updated'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: ['pk_id', 'tenant_uuid', 'document_category', 'active', 'created_at', 'updated_at'],
    title: 'DigitalScannedDocumentFeedback'
} as const;

export const $EmailNotificationsDataRequest = {
    properties: {
        health_system_filters: {
            '$ref': '#/components/schemas/DataCoordinateHealthSystemFilters'
        },
        include_provider_verification_filter: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Include Provider Verification Filter',
            default: true
        }
    },
    type: 'object',
    required: ['health_system_filters'],
    title: 'EmailNotificationsDataRequest'
} as const;

export const $Error = {
    properties: {
        code: {
            type: 'string',
            title: 'Code',
            description: 'Error code specifiying type of error'
        },
        message: {
            type: 'string',
            title: 'Message',
            description: 'Human readable message describing error'
        },
        params: {
            anyOf: [
                {
                    items: {},
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Params',
            description: 'The parameters involved in the error'
        }
    },
    type: 'object',
    required: ['code', 'message'],
    title: 'Error',
    description: ''
} as const;

export const $ErrorHTTPResponse = {
    properties: {
        errors: {
            items: {
                '$ref': '#/components/schemas/Error'
            },
            type: 'array',
            title: 'Errors',
            description: 'List of all errors'
        }
    },
    type: 'object',
    required: ['errors'],
    title: 'ErrorHTTPResponse'
} as const;

export const $File = {
    properties: {
        file_id: {
            type: 'integer',
            title: 'File Id'
        },
        file_name: {
            type: 'string',
            title: 'File Name'
        },
        provider_specified_file_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider Specified File Name'
        },
        file_path: {
            type: 'string',
            title: 'File Path'
        },
        file_size: {
            type: 'string',
            title: 'File Size'
        },
        file_uuid: {
            type: 'string',
            format: 'uuid4',
            title: 'File Uuid'
        },
        file_status: {
            '$ref': '#/components/schemas/RMFileUploadStatus'
        },
        file_status_metadata: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/FileUploadStatusMetadata'
                },
                {
                    type: 'null'
                }
            ]
        },
        user_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Uuid'
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            title: 'Updated At'
        },
        cdr_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cdr Uuid'
        },
        is_auto_generated: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Auto Generated'
        }
    },
    type: 'object',
    required: ['file_id', 'file_name', 'file_path', 'file_size', 'file_uuid', 'file_status'],
    title: 'File'
} as const;

export const $FileUpload = {
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid4',
            title: 'Uuid'
        },
        group_uuid: {
            type: 'string',
            format: 'uuid4',
            title: 'Group Uuid'
        },
        master_upload_id: {
            type: 'integer',
            title: 'Master Upload Id'
        },
        files: {
            items: {
                '$ref': '#/components/schemas/File'
            },
            type: 'array',
            title: 'Files'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            title: 'Created At'
        },
        updated_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Updated At'
        },
        file_upload_type: {
            '$ref': '#/components/schemas/RMFileUploadType'
        },
        outreach_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Outreach Id'
        },
        provider_package_display_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider Package Display Id'
        },
        chart_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Chart Id'
        },
        record_request_display_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Record Request Display Id'
        },
        num_files: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Num Files'
        },
        tenant_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tenant Uuid'
        },
        chase_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Chase Uuid'
        }
    },
    type: 'object',
    required: ['uuid', 'group_uuid', 'master_upload_id', 'files', 'created_at', 'file_upload_type'],
    title: 'FileUpload'
} as const;

export const $FileUploadEntry = {
    properties: {
        master_upload_id: {
            type: 'integer',
            title: 'Master Upload Id'
        },
        file_id: {
            type: 'integer',
            title: 'File Id'
        },
        file_status: {
            '$ref': '#/components/schemas/RMFileUploadStatus'
        },
        file_status_metadata: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/FileUploadStatusMetadata'
                },
                {
                    type: 'null'
                }
            ]
        },
        file_name: {
            type: 'string',
            title: 'File Name'
        },
        provider_specified_file_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider Specified File Name'
        },
        file_path: {
            type: 'string',
            title: 'File Path'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            title: 'Created At'
        },
        updated_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Updated At'
        },
        user_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Uuid'
        },
        cdr_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cdr Uuid'
        },
        uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Uuid'
        },
        file_size: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'File Size'
        }
    },
    type: 'object',
    required: ['master_upload_id', 'file_id', 'file_status', 'file_name', 'file_path', 'created_at'],
    title: 'FileUploadEntry'
} as const;

export const $FileUploadStatusMetadata = {
    properties: {
        s3_object_key: {
            type: 'string',
            title: 'S3 Object Key'
        },
        azure_file_path: {
            type: 'string',
            title: 'Azure File Path'
        },
        cdr_uuid: {
            type: 'string',
            title: 'Cdr Uuid'
        },
        ai_single_upload_uuid: {
            type: 'string',
            title: 'Ai Single Upload Uuid'
        }
    },
    type: 'object',
    required: ['s3_object_key'],
    title: 'FileUploadStatusMetadata'
} as const;

export const $Gender = {
    type: 'string',
    enum: ['M', 'F', 'O', 'U'],
    title: 'Gender'
} as const;

export const $GroupIdSearchRequest = {
    properties: {
        search_term: {
            type: 'string',
            title: 'Search Term'
        },
        health_system_filters: {
            '$ref': '#/components/schemas/DataCoordinateHealthSystemFilters'
        },
        search_filters: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/DataCoordinateSearchFilters'
                },
                {
                    type: 'null'
                }
            ]
        },
        include_provider_verification_filter: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Include Provider Verification Filter',
            default: false
        }
    },
    type: 'object',
    required: ['search_term', 'health_system_filters'],
    title: 'GroupIdSearchRequest'
} as const;

export const $GroupIdSearchResponse = {
    properties: {
        group_ids: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Group Ids'
        }
    },
    type: 'object',
    required: ['group_ids'],
    title: 'GroupIdSearchResponse'
} as const;

export const $HTTPValidationError = {
    properties: {
        detail: {
            items: {
                '$ref': '#/components/schemas/ValidationError'
            },
            type: 'array',
            title: 'Detail'
        }
    },
    type: 'object',
    title: 'HTTPValidationError'
} as const;

export const $ManualImportDataCoordinatesRequest = {
    properties: {
        provider_package_display_id: {
            type: 'string',
            title: 'Provider Package Display Id'
        },
        health_system_id: {
            type: 'string',
            title: 'Health System Id'
        }
    },
    type: 'object',
    required: ['provider_package_display_id', 'health_system_id'],
    title: 'ManualImportDataCoordinatesRequest'
} as const;

export const $ManualImportDataCoordinatesResponse = {
    properties: {
        imported_count: {
            type: 'integer',
            title: 'Imported Count'
        }
    },
    type: 'object',
    required: ['imported_count'],
    title: 'ManualImportDataCoordinatesResponse'
} as const;

export const $ManualUploadFile = {
    properties: {
        pk_id: {
            type: 'integer',
            title: 'Pk Id',
            description: 'The unique identifier of the manual upload'
        },
        uuid: {
            type: 'string',
            format: 'uuid4',
            title: 'Uuid',
            description: 'The uuid of the manual upload'
        },
        chase_pk_id: {
            type: 'integer',
            title: 'Chase Pk Id',
            description: 'The Chase ID associated with the manual upload'
        },
        file_path: {
            type: 'string',
            title: 'File Path',
            description: 'The path of the uploaded file'
        },
        uploaded_at: {
            type: 'string',
            format: 'date-time',
            title: 'Uploaded At',
            description: 'DateTime when the file was uploaded'
        }
    },
    type: 'object',
    required: ['pk_id', 'uuid', 'chase_pk_id', 'file_path', 'uploaded_at'],
    title: 'ManualUploadFile'
} as const;

export const $ManualUploadFileRequest = {
    properties: {
        chase_uuid: {
            type: 'string',
            title: 'Chase Uuid',
            description: 'The Chase UUID associated with the manual upload'
        },
        file_path: {
            type: 'string',
            title: 'File Path',
            description: 'The path of the uploaded file in S3'
        }
    },
    type: 'object',
    required: ['chase_uuid', 'file_path'],
    title: 'ManualUploadFileRequest'
} as const;

export const $MasterChaseUpdateRequest = {
    properties: {
        status: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/ChaseStatus'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The status of where the MasterChase is in its lifecycle (e.g. created, processing, failed, successful, etc.)'
        },
        status_metadata: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status Metadata',
            description: "Metadata/notes about the MasterChase's status (such as external status associated with the MasterChase domain status)."
        },
        fulfilled_by_hs_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fulfilled By Hs Id',
            description: 'The health system id that fulfilled a chase.'
        }
    },
    type: 'object',
    required: ['status', 'status_metadata'],
    title: 'MasterChaseUpdateRequest',
    description: 'Model that captures the MasterChase data to be updated.'
} as const;

export const $NonEmbeddedImplementationStatus = {
    type: 'string',
    enum: ['EMR_SUBMITTED', 'DOCUSIGN_COMPLETED', 'CREDENTIALS_SUBMITTED', 'CREDENTIALS_TEST_SUCCESSFUL', 'CREDENTIALS_TEST_FAILED', 'INSTALLED', 'BACKLOAD_COMPLETED', 'ENCOUNTER_FEEDBACK_COMPLETED', 'SCANNED_DOCUMENT_FEEDBACK_COMPLETED', 'QC_STARTED', 'QC_FAILED', 'QC_READY', 'QC_COMPLETED', 'ADDRESS_FEEDBACK_COMPLETED', 'LIVE'],
    title: 'NonEmbeddedImplementationStatus'
} as const;

export const $OutreachNotificationsDataRequest = {
    properties: {
        health_system_filters: {
            '$ref': '#/components/schemas/DataCoordinateHealthSystemFilters'
        },
        include_provider_verification_filter: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Include Provider Verification Filter',
            default: true
        }
    },
    type: 'object',
    required: ['health_system_filters'],
    title: 'OutreachNotificationsDataRequest'
} as const;

export const $OutreachRepushRequest = {
    properties: {
        outreach_ids: {
            items: {
                type: 'integer'
            },
            type: 'array',
            title: 'Outreach Ids'
        }
    },
    type: 'object',
    required: ['outreach_ids'],
    title: 'OutreachRepushRequest'
} as const;

export const $OutreachRepushResult = {
    properties: {
        successful_outreach_uploads: {
            items: {
                type: 'integer'
            },
            type: 'array',
            title: 'Successful Outreach Uploads'
        },
        failed_outreach_uploads: {
            items: {
                type: 'integer'
            },
            type: 'array',
            title: 'Failed Outreach Uploads'
        }
    },
    type: 'object',
    required: ['successful_outreach_uploads', 'failed_outreach_uploads'],
    title: 'OutreachRepushResult'
} as const;

export const $Page_DigitalEncounterFeedback_ = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/DigitalEncounterFeedback'
            },
            type: 'array',
            title: 'Items'
        },
        total: {
            type: 'integer',
            minimum: 0,
            title: 'Total'
        },
        page: {
            type: 'integer',
            minimum: 1,
            title: 'Page'
        },
        size: {
            type: 'integer',
            minimum: 1,
            title: 'Size'
        },
        pages: {
            type: 'integer',
            minimum: 0,
            title: 'Pages'
        }
    },
    type: 'object',
    required: ['items', 'total', 'page', 'size', 'pages'],
    title: 'Page[DigitalEncounterFeedback]'
} as const;

export const $Page_DigitalScannedDocumentFeedback_ = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/DigitalScannedDocumentFeedback'
            },
            type: 'array',
            title: 'Items'
        },
        total: {
            type: 'integer',
            minimum: 0,
            title: 'Total'
        },
        page: {
            type: 'integer',
            minimum: 1,
            title: 'Page'
        },
        size: {
            type: 'integer',
            minimum: 1,
            title: 'Size'
        },
        pages: {
            type: 'integer',
            minimum: 0,
            title: 'Pages'
        }
    },
    type: 'object',
    required: ['items', 'total', 'page', 'size', 'pages'],
    title: 'Page[DigitalScannedDocumentFeedback]'
} as const;

export const $PatchAiRawResultPayload = {
    properties: {
        patient_info: {
            items: {
                '$ref': '#/components/schemas/BulkUploadPatientAIResult'
            },
            type: 'array',
            title: 'Patient Info'
        }
    },
    type: 'object',
    required: ['patient_info'],
    title: 'PatchAiRawResultPayload'
} as const;

export const $PatchFinalUuidPayload = {
    properties: {
        reference_id: {
            type: 'string',
            title: 'Reference Id'
        },
        final_cdr_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Final Cdr Uuid'
        },
        generated_file_upload_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Generated File Upload Uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            title: 'Created At'
        },
        upload_origin: {
            '$ref': '#/components/schemas/BulkUploadAiProcessingUploadOriginEnum'
        }
    },
    type: 'object',
    required: ['reference_id', 'created_at', 'upload_origin'],
    title: 'PatchFinalUuidPayload'
} as const;

export const $PostFailedAiMatchRequest = {
    properties: {
        group_id: {
            type: 'string',
            title: 'Group Id'
        },
        reason: {
            '$ref': '#/components/schemas/BulkUploadAiProcessingResultEnum'
        },
        original_file_upload_uuid: {
            type: 'string',
            title: 'Original File Upload Uuid'
        },
        original_cdr_uuid: {
            type: 'string',
            title: 'Original Cdr Uuid'
        },
        upload_origin: {
            '$ref': '#/components/schemas/BulkUploadAiProcessingUploadOriginEnum'
        }
    },
    type: 'object',
    required: ['group_id', 'reason', 'original_file_upload_uuid', 'original_cdr_uuid', 'upload_origin'],
    title: 'PostFailedAiMatchRequest'
} as const;

export const $PractitionerInputRequest = {
    properties: {
        health_system_filters: {
            '$ref': '#/components/schemas/DataCoordinateHealthSystemFilters'
        },
        include_provider_verification_filter: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Include Provider Verification Filter',
            default: true
        }
    },
    type: 'object',
    required: ['health_system_filters'],
    title: 'PractitionerInputRequest'
} as const;

export const $PractitionerName = {
    properties: {
        first_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'First Name'
        },
        last_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Name'
        }
    },
    type: 'object',
    title: 'PractitionerName'
} as const;

export const $PrimaryReason = {
    type: 'string',
    enum: ['attorney', 'hospital_lien', 'patient_directive', 'personal_injury', 'social_security_disability', 'subpoena', 'workers_comp', 'illinois_industrial_commission_subpoena', 'florida_statute', 'veterans_disability', 'ssa_appeal_representative_form_1696', 'patient_social_security_appeal', 'life_sciences', 'audit_of_claims', 'clinical_research', 'disability', 'insurance', 'medicare_medicaid', 'rac', 'revenue_cycle_management', 'business_office_copy_risk_management', 'special_project', 'drg_payment_integrity', 'hedis_audit', 'hix', 'radv', 'standard_insurance_claim_payment', 'utilization_review', 'disability_gov_benefits', 'forms_completion_by_provider', 'patient_personal', 'patient_transfer', 'second_request_not_work_comp', 'agency', 'government_audit', 'medicaid_dds', 'non_profit', 'state_dds', 'workers_comp_board', 'continuity_of_care', 'ciox_audit', 'mra', 'ciox_real_world_data_team_request', 'aca_hix', 'drg', 'underwriting', 'claim', 'general_attorney', 'general_attorney_subpoena', 'workers_comp_subpoena', 'ssa_appeal', 'pro_medicaid', 'standard_pro', 'value_based_care', 'payd', 'payer', 'mcaid', 'attestation', 'unknown'],
    title: 'PrimaryReason'
} as const;

export const $ProviderVerificationCreateRequest = {
    properties: {
        health_system_id: {
            type: 'string',
            title: 'Health System Id'
        },
        provider_first_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider First Name'
        },
        provider_last_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider Last Name'
        },
        is_verified: {
            type: 'boolean',
            title: 'Is Verified'
        },
        last_modified_by_user_uuid: {
            type: 'string',
            title: 'Last Modified By User Uuid'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: ['health_system_id', 'is_verified', 'last_modified_by_user_uuid'],
    title: 'ProviderVerificationCreateRequest'
} as const;

export const $ProviderVerificationGetResponse = {
    properties: {
        verifications: {
            items: {
                '$ref': '#/components/schemas/PydanticProviderVerificationDisplay'
            },
            type: 'array',
            title: 'Verifications'
        }
    },
    type: 'object',
    required: ['verifications'],
    title: 'ProviderVerificationGetResponse'
} as const;

export const $ProviderVerificationResponse = {
    properties: {
        pk_id: {
            type: 'integer',
            title: 'Pk Id'
        },
        health_system_id: {
            type: 'string',
            title: 'Health System Id'
        },
        provider_first_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider First Name'
        },
        provider_last_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider Last Name'
        },
        is_verified: {
            type: 'boolean',
            title: 'Is Verified'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            title: 'Created At'
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            title: 'Updated At'
        },
        last_modified_by_user_uuid: {
            type: 'string',
            title: 'Last Modified By User Uuid'
        },
        deleted: {
            type: 'boolean',
            title: 'Deleted'
        }
    },
    type: 'object',
    required: ['pk_id', 'health_system_id', 'is_verified', 'created_at', 'updated_at', 'last_modified_by_user_uuid', 'deleted'],
    title: 'ProviderVerificationResponse'
} as const;

export const $ProviderVerificationUpdateRequest = {
    properties: {
        health_system_id: {
            type: 'string',
            title: 'Health System Id'
        },
        provider_first_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider First Name'
        },
        provider_last_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider Last Name'
        },
        is_verified: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Verified'
        },
        last_modified_by_user_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By User Uuid'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: ['health_system_id'],
    title: 'ProviderVerificationUpdateRequest'
} as const;

export const $PydanticDataCoordinate = {
    properties: {
        pk_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Pk Id',
            description: 'The primary key ID of the data coordinate.'
        },
        reference_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reference Id',
            description: 'The external reference ID of the data coordinate. Used for display and communcation.'
        },
        cf_project_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cf Project Id',
            description: 'The chart finder project ID. Only used when creating orders.'
        },
        cf_outreach_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cf Outreach Id',
            description: 'The chart finder outreach ID.'
        },
        cf_chart_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cf Chart Id',
            description: 'The chart finder chart ID. To be consolidated with reference_id.'
        },
        hs_erequest_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Hs Erequest Id',
            description: 'The health system e-request ID.'
        },
        cf_site_clean_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cf Site Clean Id',
            description: 'The chart finder site clean ID. Might be empty'
        },
        cf_emr_site_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cf Emr Site Id',
            description: 'The chart finder EMR site ID. Used to identify vend v.s. fhir worker'
        },
        assigned_to_health_system_ids: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Assigned To Health System Ids',
            description: 'The list of health system IDs the chase is assigned to. Used for manual import'
        },
        fulfilled_by_health_system_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fulfilled By Health System Id',
            description: 'The health system ID that fulfills the order.'
        },
        primary_phone_num: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Primary Phone Num',
            description: "The outreach's primary site's primary phone number."
        },
        primary_fax_num: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Primary Fax Num',
            description: "The outreach's primary site's primary fax number."
        },
        requester_type: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/RequesterType'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The type of requester.'
        },
        requester_display_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Requester Display Name',
            description: 'The display name of the requester.'
        },
        primary_reason: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/PrimaryReason'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The primary reason for the order.'
        },
        retrieval_method: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/RequestManagerRetrievalMethod'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The retrieval method.'
        },
        project_start_date: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Project Start Date',
            description: 'The start date of the project.'
        },
        project_due_date: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Project Due Date',
            description: 'The due date of the project.'
        },
        display_due_date: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Display Due Date',
            description: 'The due date that we display to users. Most likely scheduled date.'
        },
        dos_start_date: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Dos Start Date',
            description: 'The start date of the DOS.'
        },
        dos_end_date: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Dos End Date',
            description: 'The end date of the DOS.'
        },
        sdos: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sdos',
            description: 'The specific DOS as a list of date ranges in a string format.'
        },
        status: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/RequestManagerRetrievalStatus'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The status of the chase.'
        },
        status_detail: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status Detail',
            description: 'The detailed status of the chase.'
        },
        patient_first_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Patient First Name',
            description: 'The first name of the patient.'
        },
        patient_last_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Patient Last Name',
            description: 'The last name of the patient.'
        },
        patient_sex: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/Gender'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The sex of the patient.'
        },
        patient_date_of_birth: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Patient Date Of Birth',
            description: 'The date of birth of the patient.'
        },
        practitioner_first_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Practitioner First Name',
            description: 'The first name of the practitioner.'
        },
        practitioner_last_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Practitioner Last Name',
            description: 'The last name of the practitioner.'
        },
        pnp_counts: {
            anyOf: [
                {
                    additionalProperties: {
                        type: 'integer'
                    },
                    type: 'object'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Pnp Counts',
            description: 'PNP counts of all providers assigned to this request.'
        },
        provider_is_verified: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider Is Verified',
            description: 'Whether the provider is verified by the health system.'
        },
        chart_tracking_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Chart Tracking Id',
            description: 'The chart tracking ID generated by IDSB (also referenced in CF).'
        },
        idsb_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Idsb Group Id',
            description: 'The IDSB group ID, synonymous to CF outreach ID.'
        },
        idsb_request_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Idsb Request Id',
            description: 'The IDSB request ID. To be consolidated with reference_id.'
        },
        df_health_system_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Df Health System Id',
            description: 'The Data Foundation health system ID.'
        },
        df_master_address_key: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Df Master Address Key',
            description: 'The Data Foundation master address key.'
        },
        created_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created At',
            description: 'Created timestamp.'
        },
        updated_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Updated At',
            description: 'Last updated timestamp.'
        },
        is_active: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Active',
            description: 'Dedupes request with the same chart tracking ID, but different origin.'
        },
        request_origin: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/RequestOrigin'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Determines which system set the retrieval method.'
        },
        outreach_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Outreach Id',
            description: 'The outreach ID.'
        },
        chart_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Chart Id',
            description: 'The chart ID.'
        },
        cdr_document_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cdr Document Id',
            description: 'The CDR document UUID.'
        },
        max_scheduled_date: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Max Scheduled Date',
            description: 'The maximum scheduled date of the project.'
        },
        record_request_display_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Record Request Display Id',
            description: 'The display ID of the record request generated by Switchboard. To be consolidated with reference_id.'
        },
        retrieval_target_display_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Retrieval Target Display Id',
            description: 'The display ID of the retrieval target generated by Switchboard. To be consolidated with reference_id.'
        },
        provider_package_display_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider Package Display Id',
            description: 'The display ID for the provider package.'
        },
        group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Group Id',
            description: 'The unified group ID of the data coordinate. (cf_outreach_id or provider_package_display_id)'
        },
        request_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Request Id',
            description: 'The unified request ID of the data coordinate. (cf_chart_id or reference_id)'
        },
        provider_package_cdr_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider Package Cdr Uuid',
            description: 'The CDR UUID for the provider package.'
        },
        deda_updated_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deda Updated At',
            description: 'The last updated timestamp from DEDA.'
        },
        practitioner_display_first_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Practitioner Display First Name',
            readOnly: true
        },
        practitioner_display_last_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Practitioner Display Last Name',
            readOnly: true
        }
    },
    type: 'object',
    required: ['practitioner_display_first_name', 'practitioner_display_last_name'],
    title: 'PydanticDataCoordinate'
} as const;

export const $PydanticProviderVerificationDisplay = {
    properties: {
        pk_id: {
            type: 'integer',
            title: 'Pk Id',
            description: 'The primary key ID of the data coordinate.'
        },
        health_system_id: {
            type: 'string',
            title: 'Health System Id',
            description: 'The health system associated with the provider.'
        },
        provider_first_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider First Name',
            description: "The provider's first name."
        },
        provider_last_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider Last Name',
            description: "The provider's last name."
        },
        is_verified: {
            type: 'boolean',
            title: 'Is Verified',
            description: 'States whether the provider is verified or not.'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            title: 'Created At',
            description: 'The date and time the record was created.'
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            title: 'Updated At',
            description: 'The date and time the record was last updated.'
        },
        last_modified_by_user_uuid: {
            type: 'string',
            title: 'Last Modified By User Uuid',
            description: 'The UUID of the user who last modified the record.'
        },
        user_first_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User First Name',
            description: 'The first name of the user who last modified the record.'
        },
        user_last_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Last Name',
            description: 'The last name of the user who last modified the record.'
        },
        user_email_address: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Email Address',
            description: 'The email address of the user who last modified the record.'
        }
    },
    type: 'object',
    required: ['pk_id', 'health_system_id', 'is_verified', 'created_at', 'updated_at', 'last_modified_by_user_uuid'],
    title: 'PydanticProviderVerificationDisplay'
} as const;

export const $PydanticQualityCheck = {
    properties: {
        pk_id: {
            type: 'integer',
            title: 'Pk Id',
            description: 'The primary key ID of the quality check.'
        },
        tenant_uuid: {
            type: 'string',
            title: 'Tenant Uuid',
            description: 'The tenant UUID associated with the quality check.'
        },
        data_coordinate_pk_id: {
            type: 'integer',
            title: 'Data Coordinate Pk Id',
            description: 'The data coordinate primary key ID associated with the quality check.'
        },
        tracking_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tracking Id',
            description: 'The tracking ID of the quality check.'
        },
        document_location: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Location',
            description: 'The CDR document location of the quality check records.'
        },
        status: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/StatusEnum'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The status of quality check fulfillment.'
        },
        status_message: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status Message',
            description: 'The status message of the quality check fulfillment.'
        },
        approved: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approved',
            description: 'If the user approved/denied the quality check.'
        },
        feedback: {
            anyOf: [
                {
                    items: {
                        '$ref': '#/components/schemas/RejectReasonsEnum'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Feedback',
            description: 'User feedback for the quality check.'
        },
        feedback_comment: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Feedback Comment',
            description: 'User feedback comment for the quality check.'
        },
        feedback_email: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Feedback Email',
            description: 'The user email associated with the quality check feedback.'
        },
        owner_email: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Owner Email',
            description: 'The DVer email that triggered the quality check.'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            title: 'Created At',
            description: 'The datetime the quality check record was created.'
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            title: 'Updated At',
            description: 'The datetime the quality check record was last updated.'
        },
        completed_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Completed At',
            description: 'The datetime the quality check finished fulfillment (for both success/failure).'
        }
    },
    type: 'object',
    required: ['pk_id', 'tenant_uuid', 'data_coordinate_pk_id', 'created_at', 'updated_at'],
    title: 'PydanticQualityCheck'
} as const;

export const $PydanticSmartOutreach = {
    properties: {
        pk_id: {
            type: 'integer',
            title: 'Pk Id',
            description: 'The primary key ID of the smart outreach record.'
        },
        tenant_uuid: {
            type: 'string',
            title: 'Tenant Uuid',
            description: 'The tenant UUID associated with the smart outreach record.'
        },
        rule_name: {
            '$ref': '#/components/schemas/RuleEnum',
            description: 'The name of the rule associated with the smart outreach record.'
        },
        last_checked_at: {
            type: 'string',
            format: 'date-time',
            title: 'Last Checked At',
            description: 'The datetime the smart outreach rule was last checked.'
        },
        defer_until: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Defer Until',
            description: 'The datetime the smart outreach rule is deferred until.'
        },
        status: {
            '$ref': '#/components/schemas/SmartOutreachStatusEnum',
            description: 'The status of the smart outreach rule.'
        },
        rule_metadata: {
            anyOf: [
                {
                    additionalProperties: true,
                    type: 'object'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rule Metadata',
            description: 'Additional metadata associated with the smart outreach rule.'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            title: 'Created At',
            description: 'The datetime the smart outreach rule was created.'
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            title: 'Updated At',
            description: 'The datetime the smart outreach rule was last updated.'
        }
    },
    type: 'object',
    required: ['pk_id', 'tenant_uuid', 'rule_name', 'last_checked_at', 'status', 'created_at', 'updated_at'],
    title: 'PydanticSmartOutreach'
} as const;

export const $PydanticStandardSingleUpload = {
    properties: {
        upload_master_uuid: {
            type: 'string',
            title: 'Upload Master Uuid',
            description: 'The uploads_master uuid.'
        },
        standard_single_upload_uuid: {
            type: 'string',
            title: 'Standard Single Upload Uuid',
            description: 'The standard single upload uuid.'
        },
        tenant_uuid: {
            type: 'string',
            title: 'Tenant Uuid',
            description: 'The tenant uuid.'
        },
        data_coordinate: {
            '$ref': '#/components/schemas/PydanticDataCoordinate',
            description: 'The data coordinate of the upload group.'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            title: 'Created At',
            description: 'The created date of the upload group.'
        },
        files: {
            items: {
                '$ref': '#/components/schemas/FileUploadEntry'
            },
            type: 'array',
            title: 'Files',
            description: 'The files uploaded.',
            default: []
        }
    },
    type: 'object',
    required: ['upload_master_uuid', 'standard_single_upload_uuid', 'tenant_uuid', 'data_coordinate', 'created_at'],
    title: 'PydanticStandardSingleUpload',
    description: 'Represents a group of single uploads for a chart in RM Standard.'
} as const;

export const $RMFileUploadStatus = {
    type: 'string',
    enum: ['UPLOADED_S3', 'UPLOADING_AZURE_FILESHARE', 'UPLOADING_AZURE_FILESHARE_FAILED', 'UPLOADED_AZURE_FILESHARE', 'FILE_CONVERSION_FAILED', 'FILE_MERGING_FAILED', 'UPLOADING_CDR', 'UPLOADING_CDR_FAILED', 'UPLOADED_CDR', 'UPLOADING_CHARTFINDER', 'UPLOADING_CHARTFINDER_FAILED', 'UPLOADED_CHARTFINDER', 'UPLOADING_HUB_FAILED', 'UPLOADING_HUB', 'UPLOADED_HUB', 'UPLOADING_SWITCHBOARD', 'UPLOADED_SWITCHBOARD', 'UPLOADING_SWITCHBOARD_FAILED', 'AI_PROCESSING_SUCCESSFUL', 'AI_PROCESSING_FAILED', 'AI_RESULT_READY', 'SENT_FOR_AI_PROCESSING'],
    title: 'RMFileUploadStatus'
} as const;

export const $RMFileUploadType = {
    type: 'string',
    enum: ['BASIC_SINGLE', 'BASIC_BULK', 'STANDARD_SINGLE', 'STANDARD_BULK'],
    title: 'RMFileUploadType'
} as const;

export const $RRAFilter = {
    properties: {
        exclude_idsb_digital_failed_or_processing: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Exclude Idsb Digital Failed Or Processing',
            default: false
        },
        exclude_non_completed_digital_connections: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Exclude Non Completed Digital Connections',
            default: false
        }
    },
    type: 'object',
    title: 'RRAFilter'
} as const;

export const $RejectReasonsEnum = {
    type: 'string',
    enum: ['The PDF is missing information that would be manually pulled for the request.', 'The PDF includes information that would not be manually pulled for the request.', 'Other'],
    title: 'RejectReasonsEnum'
} as const;

export const $RequestManagerOutreachNotificationsDataResponse = {
    properties: {
        group_ids_data: {
            additionalProperties: {
                additionalProperties: {
                    type: 'string'
                },
                type: 'object'
            },
            type: 'object',
            title: 'Group Ids Data',
            description: "Key: Request ID, Value: dict containing 'due_date' and 'request_origin'",
            default: {}
        },
        request_ids_data: {
            additionalProperties: {
                additionalProperties: {
                    type: 'string'
                },
                type: 'object'
            },
            type: 'object',
            title: 'Request Ids Data',
            description: "Request ids and their associated due dates and request origins e.g. { 'R1234': {'due_date': '10-05-2025', 'request_origin': 'CHART_FINDER' }",
            default: {}
        }
    },
    type: 'object',
    title: 'RequestManagerOutreachNotificationsDataResponse',
    description: 'Outreach IDs for chases about to be flipped to manual outreach.'
} as const;

export const $RequestManagerRetrievalMethod = {
    type: 'string',
    enum: ['REQUEST_MANAGER_DIRECT', 'REQUEST_MANAGER_TRADITIONAL', 'DIGITAL_HEALTH_JUMP', 'DIGITAL_FHIR_WORKER', 'DIGITAL_VENDOR_DIRECT', 'TRADITIONAL_MANUAL', 'TRADITIONAL_ONSITE', 'EMBEDDED', 'OTHER', 'DIGITAL_CONNECTIONS'],
    title: 'RequestManagerRetrievalMethod',
    description: 'RM Retrieval Types.'
} as const;

export const $RequestManagerRetrievalStatus = {
    type: 'string',
    enum: ['PENDING_OPEN', 'OPEN', 'PROCESSING', 'COMPLETED', 'CANCELLED', 'FAILED', 'INTERNAL_HOLDING', 'NOT_YET_RETRIEVED', 'DELETED', 'PAYMENT_REQUESTED'],
    title: 'RequestManagerRetrievalStatus',
    description: 'RM Retrieval Status.'
} as const;

export const $RequestManagerSortOption = {
    type: 'string',
    enum: ['patient_name', 'due_date'],
    title: 'RequestManagerSortOption',
    description: 'RM Sort Options.'
} as const;

export const $RequestOrigin = {
    type: 'string',
    enum: ['IDSB', 'CHART_FINDER', 'HUB', 'IDSB_V2'],
    title: 'RequestOrigin',
    description: 'Origin of RM requests'
} as const;

export const $RequesterType = {
    type: 'string',
    enum: ['attorney', 'datavant', 'disability', 'continuing_care', 'copya', 'copyi', 'facility', 'government', 'insurance', 'patient', 'payd', 'payi', 'pro', 'fac'],
    title: 'RequesterType'
} as const;

export const $RerouteUpsertInput = {
    properties: {
        df_health_system_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Df Health System Id'
        },
        df_master_address_key: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Df Master Address Key'
        },
        df_request_uuid: {
            anyOf: [
                {
                    type: 'string',
                    format: 'uuid'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Df Request Uuid'
        },
        cf_outreach_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cf Outreach Id'
        }
    },
    type: 'object',
    title: 'RerouteUpsertInput'
} as const;

export const $RuleEnum = {
    type: 'string',
    enum: ['RULE_INACTIVE_PROVIDER', 'RULE_RRA_IMPL', 'RULE_ROLLOUT_PHASE', 'RULE_THROUGHPUT_SUPPRESSION'],
    title: 'RuleEnum'
} as const;

export const $SingleFileUploadRequest = {
    properties: {
        files: {
            items: {
                '$ref': '#/components/schemas/SingleFileUploadRequestFile'
            },
            type: 'array',
            title: 'Files'
        },
        chart_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Chart Id'
        },
        record_request_display_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Record Request Display Id'
        },
        chase_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Chase Uuid'
        },
        file_type: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/RMFileUploadType'
                },
                {
                    type: 'null'
                }
            ],
            default: 'BASIC_SINGLE'
        },
        provider_package_display_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider Package Display Id'
        },
        ai_matched: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ai Matched',
            default: false
        }
    },
    type: 'object',
    required: ['files'],
    title: 'SingleFileUploadRequest'
} as const;

export const $SingleFileUploadRequestFile = {
    properties: {
        uuid: {
            type: 'string',
            title: 'Uuid'
        },
        file_name: {
            type: 'string',
            title: 'File Name'
        },
        file_path: {
            type: 'string',
            title: 'File Path'
        },
        file_size: {
            type: 'string',
            title: 'File Size'
        },
        user_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Uuid'
        },
        provider_specified_file_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider Specified File Name'
        },
        cdr_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cdr Uuid'
        }
    },
    type: 'object',
    required: ['uuid', 'file_name', 'file_path', 'file_size'],
    title: 'SingleFileUploadRequestFile'
} as const;

export const $SingleUpload = {
    properties: {
        chart_id: {
            type: 'string',
            title: 'Chart Id'
        },
        files: {
            items: {
                '$ref': '#/components/schemas/SingleUploadFile'
            },
            type: 'array',
            title: 'Files'
        },
        num_files: {
            type: 'integer',
            title: 'Num Files'
        },
        updated_date: {
            type: 'string',
            title: 'Updated Date'
        },
        tenant_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tenant Uuid'
        },
        chase_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Chase Uuid'
        }
    },
    type: 'object',
    required: ['chart_id', 'files', 'num_files', 'updated_date'],
    title: 'SingleUpload',
    description: 'Fields that comprise a single upload.'
} as const;

export const $SingleUploadFile = {
    properties: {
        file_name: {
            type: 'string',
            title: 'File Name'
        },
        file_size: {
            type: 'string',
            title: 'File Size'
        },
        update_date: {
            type: 'string',
            title: 'Update Date'
        },
        user_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Uuid'
        },
        provider_specified_file_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider Specified File Name'
        },
        cdr_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cdr Uuid'
        }
    },
    type: 'object',
    required: ['file_name', 'file_size', 'update_date'],
    title: 'SingleUploadFile'
} as const;

export const $SmartOutreachCreateOrUpdateRequest = {
    properties: {
        tenant_uuid: {
            type: 'string',
            title: 'Tenant Uuid',
            description: 'The tenant UUID the smart outreach record is for.'
        },
        rule_name: {
            '$ref': '#/components/schemas/RuleEnum',
            description: 'The name of the rule associated with the smart outreach record.'
        },
        status: {
            '$ref': '#/components/schemas/SmartOutreachStatusEnum',
            description: 'The status of the smart outreach rule.'
        },
        metadata: {
            anyOf: [
                {
                    additionalProperties: true,
                    type: 'object'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Metadata',
            description: 'Additional metadata associated with the smart outreach rule.'
        },
        defer_until: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Defer Until',
            description: 'The datetime the smart outreach rule is deferred until.'
        }
    },
    type: 'object',
    required: ['tenant_uuid', 'rule_name', 'status'],
    title: 'SmartOutreachCreateOrUpdateRequest'
} as const;

export const $SmartOutreachStatusEnum = {
    type: 'string',
    enum: ['EXECUTED', 'SKIPPED', 'DEFERRED'],
    title: 'SmartOutreachStatusEnum'
} as const;

export const $StandardSingleUploadQueueRequest = {
    properties: {
        filters: {
            '$ref': '#/components/schemas/StandardSingleUploadSearchFilters'
        },
        limit: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Limit'
        },
        offset: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Offset'
        },
        include_total: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Include Total',
            default: false
        }
    },
    type: 'object',
    required: ['filters'],
    title: 'StandardSingleUploadQueueRequest'
} as const;

export const $StandardSingleUploadQueueResponse = {
    properties: {
        total: {
            type: 'integer',
            title: 'Total'
        },
        uploads: {
            items: {
                '$ref': '#/components/schemas/PydanticStandardSingleUpload'
            },
            type: 'array',
            title: 'Uploads'
        }
    },
    type: 'object',
    required: ['total', 'uploads'],
    title: 'StandardSingleUploadQueueResponse'
} as const;

export const $StandardSingleUploadSearchFilters = {
    properties: {
        tenant_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tenant Uuid'
        },
        upload_master_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Upload Master Uuid'
        },
        upload_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Upload Uuid'
        },
        global_search: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Global Search'
        },
        upload_date_start: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Upload Date Start'
        },
        upload_date_end: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Upload Date End'
        }
    },
    type: 'object',
    title: 'StandardSingleUploadSearchFilters'
} as const;

export const $StandardSingleUploadWithPatientInfo = {
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid4',
            title: 'Uuid'
        },
        master_upload_id: {
            type: 'integer',
            title: 'Master Upload Id'
        },
        files: {
            items: {
                '$ref': '#/components/schemas/File'
            },
            type: 'array',
            title: 'Files'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            title: 'Created At'
        },
        updated_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Updated At'
        },
        outreach_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Outreach Id'
        },
        patient_first_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Patient First Name'
        },
        patient_last_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Patient Last Name'
        },
        patient_date_of_birth: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Patient Date Of Birth'
        },
        chart_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Chart Id'
        },
        tenant_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tenant Uuid'
        },
        record_request_display_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Record Request Display Id'
        },
        provider_package_display_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Provider Package Display Id'
        },
        data_coord: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Data Coord'
        },
        num_files: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Num Files'
        }
    },
    type: 'object',
    required: ['uuid', 'master_upload_id', 'files', 'created_at'],
    title: 'StandardSingleUploadWithPatientInfo'
} as const;

export const $StatusEnum = {
    type: 'string',
    enum: ['IN_PROGRESS', 'COMPLETED', 'FAILED'],
    title: 'StatusEnum'
} as const;

export const $UpdateDigitalEncounterFeedback = {
    properties: {
        pk_id: {
            type: 'integer',
            title: 'Pk Id',
            description: 'Id of the encounter feedback entry'
        },
        active: {
            type: 'boolean',
            title: 'Active',
            description: 'Whether the encounter type is active for autofulfillment'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: ['pk_id', 'active'],
    title: 'UpdateDigitalEncounterFeedback'
} as const;

export const $UpdateDigitalScannedDocumentFeedback = {
    properties: {
        pk_id: {
            type: 'integer',
            title: 'Pk Id',
            description: 'Id of the scanned document feedback entry'
        },
        active: {
            type: 'boolean',
            title: 'Active',
            description: 'Whether the document category is active for autofulfillment'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: ['pk_id', 'active'],
    title: 'UpdateDigitalScannedDocumentFeedback'
} as const;

export const $UpdateFileUploadParams = {
    properties: {
        file_upload_uuid: {
            type: 'string',
            title: 'File Upload Uuid'
        },
        new_file_status: {
            '$ref': '#/components/schemas/RMFileUploadStatus'
        },
        new_file_status_metadata: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/FileUploadStatusMetadata'
                },
                {
                    type: 'null'
                }
            ]
        },
        cdr_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cdr Uuid'
        }
    },
    type: 'object',
    required: ['file_upload_uuid', 'new_file_status'],
    title: 'UpdateFileUploadParams'
} as const;

export const $UpdateIDSBQADataCoordinateRequest = {
    properties: {
        status: {
            anyOf: [
                {
                    type: 'string',
                    const: 'FAILED'
                },
                {
                    type: 'string',
                    const: 'COMPLETED'
                }
            ],
            title: 'Status'
        },
        cdr_document_id: {
            type: 'string',
            title: 'Cdr Document Id'
        }
    },
    type: 'object',
    required: ['status', 'cdr_document_id'],
    title: 'UpdateIDSBQADataCoordinateRequest'
} as const;

export const $UpsertIDSBDummyDataCoordinateRequest = {
    properties: {
        chart_tracking_id: {
            type: 'integer',
            title: 'Chart Tracking Id'
        },
        df_health_system_id: {
            type: 'string',
            title: 'Df Health System Id'
        },
        df_master_address_key: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Df Master Address Key'
        }
    },
    type: 'object',
    required: ['chart_tracking_id', 'df_health_system_id'],
    title: 'UpsertIDSBDummyDataCoordinateRequest'
} as const;

export const $UpsertIDSBRRAMLDataCoordinateRequest = {
    properties: {
        idsb_request_id: {
            type: 'integer',
            title: 'Idsb Request Id'
        },
        status: {
            anyOf: [
                {
                    type: 'string',
                    const: 'PROCESSING'
                },
                {
                    type: 'string',
                    const: 'COMPLETED'
                },
                {
                    type: 'string',
                    const: 'FAILED'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status'
        },
        cdr_document_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cdr Document Id'
        },
        retrieval_method: {
            anyOf: [
                {
                    type: 'string',
                    const: 'DIGITAL_FHIR_WORKER'
                },
                {
                    type: 'string',
                    const: 'DIGITAL_HEALTH_JUMP'
                },
                {
                    type: 'string',
                    const: 'DIGITAL_CONNECTIONS'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Retrieval Method'
        },
        df_health_system_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Df Health System Id'
        },
        requester_type: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/RequesterType'
                },
                {
                    type: 'null'
                }
            ]
        },
        requester_display_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Requester Display Name'
        },
        primary_reason: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/PrimaryReason'
                },
                {
                    type: 'null'
                }
            ]
        },
        dos_start_date: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Dos Start Date'
        },
        dos_end_date: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Dos End Date'
        },
        patient_first_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Patient First Name'
        },
        patient_last_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Patient Last Name'
        },
        patient_sex: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/Gender'
                },
                {
                    type: 'null'
                }
            ]
        },
        patient_date_of_birth: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Patient Date Of Birth'
        },
        practitioner_first_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Practitioner First Name'
        },
        practitioner_last_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Practitioner Last Name'
        },
        project_due_date: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Project Due Date'
        },
        cf_chart_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cf Chart Id'
        }
    },
    type: 'object',
    required: ['idsb_request_id'],
    title: 'UpsertIDSBRRAMLDataCoordinateRequest'
} as const;

export const $UpsertSuccessAiMatchRequest = {
    properties: {
        reference_id: {
            type: 'string',
            title: 'Reference Id'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            title: 'Created At'
        },
        group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Group Id'
        },
        original_file_upload_uuids: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Original File Upload Uuids'
        },
        original_cdr_uuids: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Original Cdr Uuids'
        },
        upload_origin: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/BulkUploadAiProcessingUploadOriginEnum'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    required: ['reference_id', 'created_at'],
    title: 'UpsertSuccessAiMatchRequest'
} as const;

export const $ValidationError = {
    properties: {
        loc: {
            items: {
                anyOf: [
                    {
                        type: 'string'
                    },
                    {
                        type: 'integer'
                    }
                ]
            },
            type: 'array',
            title: 'Location'
        },
        msg: {
            type: 'string',
            title: 'Message'
        },
        type: {
            type: 'string',
            title: 'Error Type'
        },
        input: {
            title: 'Input'
        },
        ctx: {
            type: 'object',
            title: 'Context'
        }
    },
    type: 'object',
    required: ['loc', 'msg', 'type'],
    title: 'ValidationError'
} as const;